
































import { PropType, defineComponent, onBeforeUnmount } from '@vue/composition-api';
import { Message } from '../../dataType';
import Card from './Card.vue';
import { useMessage } from '../../hooks/useMessage';
export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<string>>,
      required: true
    }
  },
  setup(props) {
    const { prevMessage, loadNewMessage } = useMessage();
    const reloadMessage = async () => {
      const lastMessage = prevMessage(props.message.id);
      if (lastMessage && typeof lastMessage.id === 'number') {
        loadNewMessage(lastMessage.id);
      }
    };
    // 等待时间10s后重新加载
    const timeout = setTimeout(reloadMessage, 1000 * 18);
    onBeforeUnmount(() => {
      clearTimeout(timeout);
    });
    return {};
  }
});
